import { useState, useEffect, useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  revertOnlyGreyhoundMarkets,
} from "../../../../AsianExchangeSrc/redux/slices/greyhoundSlice";
import { MdOutlineInfo } from "react-icons/md";
import { FaArrowDownLong } from "react-icons/fa6";
import {
  clearSelectedData,
  setBetData,
} from "../../../../AsianExchangeSrc/redux/slices/fullmarketSlice";
import "./index.css";
import { updateAvailableBalance } from "../../../../AsianExchangeSrc/redux/slices/userSlice";
import { fetchBets } from "../../../../AsianExchangeSrc/redux/slices/betsSlice";
import { toast } from "react-toastify";
import Menu_select from "../../components/Menu_select";
import {
  placeBet,
  subscribeToGreyHoundOddsData,
  unsubscribeFromGreyHoundOdds,
} from "../../../../socketClient";
import { getCurrentMatchExposure } from "../../../../AsianExchangeSrc/utils/getCurrentMatchExposure";
import BettingSlip from "../../components/BettingSlip";

const isPastOneMinute = (raceName) => {
  if (!raceName) return true;
  const dateTimePart = raceName.replace(/^[^\d]+/, "");
  const currentYear = new Date().getFullYear();
  const raceDate = new Date(`${dateTimePart} ${currentYear}`);
  raceDate.setMinutes(raceDate.getMinutes() + 1);
  return new Date() > raceDate;
};

const Market = () => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const gmid = searchParams.get("gmid");
  const raceName = searchParams.get("raceName");

  // State
  const [gOdds, setGreyhoundMatchodds] = useState({});
  const [selectedBet, setSelectedBet] = useState(null);
  const [localBetData, setLocalBetData] = useState(null);
  const [betType, setBetType] = useState(null);
  const [index, setIndex] = useState(null);
  const [matchIndex, setMatchIndex] = useState(null);
  const [currentValue, setCurrentValue] = useState("");
  const [calculateValue, setCalculateValue] = useState(null);
  const [acceptAnyOdds, setAcceptAnyOdds] = useState(false);
  const [liveValue, setLiveValue] = useState(null);
  const [odsValue, setOdsValue] = useState(null);
  const [loading, setLoading] = useState(false);
  const [matchOver, setMatchOver] = useState(false);
  const [openWinLosValue, setOpenWinLosValue] = useState(false);
  const [imageErrors, setImageErrors] = useState(new Set());
  const [isWideScreen, setIsWideScreen] = useState(window.innerWidth > 800);
  const [showGreyhoundDetails, setShowGreyhoundDetails] = useState(""); // Added
  const [newData, setNewData] = useState(null); // Added

  const { betData } = useSelector((state) => state.marketOdds);
  const { bets } = useSelector((state) => state.account || {});

  const oddsdata = useSelector((state) => state.greyhound.greyhoundMarkets);
  const odd = oddsdata.find((ghm) => String(ghm.gmid) === String(gmid));

  const filteredBets =
    bets?.filter(
      (bet) =>
        bet.matchId === gmid &&
        bet.markettype === "Match Odds" &&
        bet.sportsName === "Greyhound Race"
    ) || [];

  const matchOdds = odd?.odds?.find((e) => e?.mname === "MATCH_ODDS"); // Added
  useEffect(() => {
    setGreyhoundMatchodds(matchOdds || {});
  }, [matchOdds]); // Modified

  //  const fetchGreyhoundOdds = async () => {
  //       try {
  //           const response = await getGreyhoundRaceOdds(gmid);

  //           if (response.success) {
  //             setGreyhoundMatchodds(response?.data?.data?.data?.find(ghm => ghm.gmid == gmid))
  //               dispatch(updateGreyhoundMarket({ gmid, odds: response?.data?.data?.data }));

  //               if (isPastOneMinute(raceName)) {
  //                   setMatchOver(true)
  //               } else {
  //                   setMatchOver(false)
  //               }
  //           } else {
  //               setMatchOver(true)
  //           }
  //       } catch (error) {
  //           console.error("Error fetching data:", error);
  //           setMatchOver(true)
  //       }

  //   };

  useEffect(() => {
    // fetchGreyhoundOdds();
    // const fetchIntervalId = setInterval(fetchGreyhoundOdds, 2000);
    // return () => {
    //   clearInterval(fetchIntervalId);
    //   dispatch(revertOnlyGreyhoundMarkets());
    // };
    subscribeToGreyHoundOddsData({ gmid });
    return () => {
      unsubscribeFromGreyHoundOdds(gmid);
      dispatch(revertOnlyGreyhoundMarkets());
    };
  }, []);

  useEffect(() => {
    const handleResize = () => setIsWideScreen(window.innerWidth > 800);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleDataClick = useCallback(
    (runnerName, odds, type, runnerData, idx, currentMatchIndex, runners) => {
      if (!odds || !runnerData) return;
      const oddsData = {
        oddsType: type,
        odds,
        selectionId: runnerData.sid || runnerData.selectionId,
        runnerName,
        joinedMarketIds: gmid,
        sportsName: "Greyhound Race",
        matchId: gmid,
        marketId: gmid,
        eventId: 65,
        runners,
        raceName,
        market: "Greyhound Race",
        markettype: "Match Odds",
      };
      setOpenWinLosValue(true);
      setBetType(type);
      setIndex(idx);
      setMatchIndex(currentMatchIndex);
      setLocalBetData(oddsData);
      setSelectedBet(true);
      setOdsValue(odds);
      dispatch(setBetData(oddsData));
    },
    [gmid, raceName, dispatch]
  );

  const calculateBets = useCallback(
    (runner) => {
      const runnerId = runner.sid || runner.selectionId;
      let placedBetCalculation = 0;
      const fbOfthisRunner = filteredBets.filter(
        (fb) =>
          fb.selectionId.toString() === runnerId.toString() &&
          gmid.toString() === fb.matchId.toString()
      );
      fbOfthisRunner.forEach((fbr) => {
        const subject =
          fbr.type === "Back" ? fbr.favourMargin : -fbr.againstMargin;
        placedBetCalculation += subject;
      });
      const fbOfOtherRunners = filteredBets.filter(
        (fb) =>
          fb.selectionId.toString() !== runnerId.toString() &&
          gmid.toString() === fb.matchId.toString()
      );
      fbOfOtherRunners.forEach((fbor) => {
        const subject =
          fbor.type === "Back" ? -fbor.againstMargin : fbor.favourMargin;
        placedBetCalculation += subject;
      });
      return placedBetCalculation;
    },
    [filteredBets, gmid]
  );

  const calculateNewValue = useCallback(
    (runnerId, betData) => {
      if (!betData) return 0;
      const placedBetCalculation = calculateBets({ sid: runnerId });
      let newValue = 0;
      if (betData.type === "Back") {
        newValue =
          betData.selectionId !== runnerId
            ? -betData.addedValue + placedBetCalculation
            : betData.calculateValue + placedBetCalculation;
      } else {
        newValue =
          betData.selectionId !== runnerId
            ? betData.addedValue + placedBetCalculation
            : -betData.calculateValue + placedBetCalculation;
      }
      return newValue;
    },
    [calculateBets]
  );

  const [formData, setFormData] = useState({});
  useEffect(() => {
    if (!gOdds?.section || !localBetData) return;
    const runners = gOdds.section;
    setFormData({
      type: localBetData.oddsType || "",
      selection: localBetData.selectionId || "",
      selectionId: localBetData.selectionId || "",
      oddsReq: odsValue || "",
      eventId: gmid || "",
      eventType: gmid,
      leagueId: gmid || "",
      event: raceName || "",
      marketId: gmid || "",
      matchId: gmid || "",
      joinedMarketIds: gmid || "",
      market: "Match Odds",
      markettype: "Match Odds",
      sportsName: "Greyhound Race",
      againstMargin: currentValue || "",
      stake: currentValue || "",
      favourMargin: calculateValue || "",
      placeTime: new Date().toISOString(),
      runners:
        runners?.map((r) => ({
          selectionId: r.sid,
          runnerName: r.nat,
          handicap: 0,
          sortPriority: r.cno || 0,
        })) || [],
      runnersCount: runners?.length || 0,
      index: index,
    });
  }, [
    gOdds,
    localBetData,
    currentValue,
    odsValue,
    calculateValue,
    gmid,
    raceName,
    index,
  ]);

  useEffect(() => {
    if (acceptAnyOdds && liveValue) {
      setOdsValue(liveValue);
    }
  }, [acceptAnyOdds, liveValue]);

  useEffect(() => {
    if (!gOdds?.section || !localBetData) return;
    const runner = gOdds.section.find(
      (r) => r.sid === localBetData.selectionId
    );
    if (runner?.odds?.[index]?.odds) {
      setLiveValue(runner.odds[index].odds);
    }
  }, [gOdds, localBetData, index]);

  const updateCalculatedValue = useCallback(
    (value) => {
      const addedValue = Number(value) || 0;
      const calculatedValue = odsValue * value - value || 0;
      setCalculateValue(calculatedValue);
      dispatch(
        setBetData({
          calculateValue: calculatedValue,
          index,
          addedValue,
          selectionId: localBetData?.selectionId,
          type: localBetData?.oddsType,
          marketId: gmid,
        })
      );
    },
    [odsValue, index, localBetData, gmid, dispatch]
  );

  const handleCancelClick = useCallback(() => {
    setSelectedBet(null);
    setLocalBetData(null);
    setCurrentValue("");
    setCalculateValue(null);
    setOdsValue(null);
    setLiveValue(null);
    setOpenWinLosValue(false);
    dispatch(clearSelectedData());
    dispatch(
      setBetData({
        calculateValue: null,
        index: null,
        addedValue: null,
        selectionId: null,
        type: null,
        marketId: null,
      })
    );
  }, [dispatch]);

  const handleQuickButtonClick = useCallback(
    (value) => {
      setCurrentValue(value);
      updateCalculatedValue(value);
    },
    [updateCalculatedValue]
  );

  const handleNumPadClick = useCallback(
    (num) => {
      setCurrentValue((prevValue) => {
        const newValue = prevValue.toString() + num.toString();
        updateCalculatedValue(parseFloat(newValue) || 0);
        return newValue;
      });
    },
    [updateCalculatedValue]
  );

  const handleDeleteClick = useCallback(() => {
    setCurrentValue((prevValue) => {
      const newValue = prevValue.toString().slice(0, -1) || "";
      updateCalculatedValue(parseFloat(newValue) || 0);
      return newValue;
    });
  }, [updateCalculatedValue]);

  const handleIncreaseClick = useCallback(() => {
    setCurrentValue((prevValue) => {
      const newValue = (parseFloat(prevValue) || 0) + 1;
      updateCalculatedValue(newValue);
      return newValue.toString();
    });
  }, [updateCalculatedValue]);

  const handleDecreaseClick = useCallback(() => {
    setCurrentValue((prevValue) => {
      const newValue =
        parseFloat(prevValue) > 0 ? parseFloat(prevValue) - 1 : 0;
      updateCalculatedValue(newValue);
      return newValue.toString();
    });
  }, [updateCalculatedValue]);

  const handleCheckboxChange = useCallback((e) => {
    setAcceptAnyOdds(e.target.checked);
  }, []);

  const handleButtonClick = useCallback(async () => {
    setLoading(true);
    try {
      const response = await placeBet(formData);
      if (!response.success) {
        toast.warning(response.message);
      } else {
        toast.success(response.message);
        dispatch(updateAvailableBalance(response?.userData?.availableBalance));
        dispatch(fetchBets());
        handleCancelClick();
      }
    } catch (error) {
      console.error("Error placing bet:", error);
      toast.error("Failed to place bet");
    } finally {
      setLoading(false);
    }
  }, [formData, dispatch, handleCancelClick]);

  console.log(gOdds, "gOdds");

  return (
    <div className="greyhound-market-wrap">
      <Menu_select menuItems={[]} />
      <div className="market-event-container">
        <div className="w-full h-[150px] bg-black"></div>
        <div className="w-full flex items-center justify-between pr-2 mt-2">
          <div className="w-[130px] text-white h-[30px] bg-gradient-to-b from-[#2E4B5E] to-[#243A48] rounded-tr-[15px] flex items-center justify-center gap-2">
            <span className="font-bold text-[13px]">To Be Placed</span>
            <MdOutlineInfo size={19} />
          </div>
          <div className="text-[13px]">
            Matched
            <strong className="pl-1">€ 0</strong>
          </div>
        </div>

        <section className="overflow-y-scroll">
          <div className="w-full max-w-screen-xl flex flex-col bg-gray-100 ods-container-mob">
            <div className="bg-black flex justify-between items-center text-secondary match-header-mob">
              {" "}
              {/* Modified */}
              <div>
                <h3
                  className="font-bold text-xs"
                  style={{ padding: "2px 2px" }}
                >
                  {raceName}
                </h3>
              </div>
            </div>
            <div className="mobils-ods-head">
              <div
                className="mobils-ods-min"
                style={{
                  padding: "0px 8px",
                  color: "#18ADC5",
                  fontWeight: 1000,
                  fontSize: 10,
                }}
              >{`Min: 100 | Max: ${(gOdds?.umaxbof || 5000) / 1000}K`}</div>
              <div className="asian-ods-btn">
                {" "}
                {/* Modified */}
                <button>Back</button>
                <button>Lay</button>
              </div>
            </div>
            <div className="bg-white rounded-b-md overflow-hidden">
              <table className="odds-table odds-table-asian">
                <thead className="head-hide-mobile">
                  <tr>
                    <th className="section-head"></th>
                    <th className="market-top-head"></th>
                    <th className="market-top-head"></th>
                    <th className="market-top-head" style={{ padding: "0px" }}>
                      <div className="back-header">Back All</div>
                    </th>
                    <th className="market-top-head" style={{ padding: "0px" }}>
                      <div className="lay-header">Lay All</div>
                    </th>
                    <th className="market-top-head"></th>
                    <th className="market-top-head market-top-head-last"></th>
                  </tr>
                </thead>
                <tbody>
                  {gOdds?.section?.map((runner, idx) => {
                    const runnerId = runner?.sid;
                    let placedBetCalculation = 0;
                    const fbOfthisRunner = filteredBets?.filter(
                      (fb) =>
                        fb.selectionId.toString() === runner.sid.toString() &&
                        gmid.toString() === fb.matchId.toString()
                    );
                    fbOfthisRunner?.forEach((fbr) => {
                      const subject =
                        fbr.type === "Back"
                          ? fbr.favourMargin
                          : -fbr.againstMargin;
                      placedBetCalculation += subject;
                    });
                    const fbOfOtherRunners = filteredBets?.filter(
                      (fb) =>
                        fb.selectionId.toString() !== runner.sid.toString() &&
                        gmid.toString() === fb.matchId.toString()
                    );
                    fbOfOtherRunners?.forEach((fbor) => {
                      const subject =
                        fbor.type === "Back"
                          ? -fbor.againstMargin
                          : fbor.favourMargin;
                      placedBetCalculation += subject;
                    });
                    let newValue = 0;
                    if (betData?.type === "Back") {
                      newValue =
                        betData?.selectionId !== runnerId
                          ? -betData?.addedValue + placedBetCalculation
                          : betData?.calculateValue + placedBetCalculation;
                    } else {
                      newValue =
                        betData?.selectionId !== runnerId
                          ? betData?.addedValue + placedBetCalculation
                          : -betData?.calculateValue + placedBetCalculation;
                    }
                    const selfSuspend = gOdds.status === "SUSPENDED";
                    console.log({ matchOver }, "selfSuspend");

                    let formattedRunner = runner.nat.split(".");
                    formattedRunner =
                      formattedRunner?.length > 1
                        ? formattedRunner[1]
                        : runner.nat;
                    return (
                      <>
                        <tr
                          key={`asian-full-market${idx + 1}`}
                          className="asian-full-market asian-full-market-other asian-full-market-other2 px-1"
                        >
                          <td
                            style={{ textAlign: "start", padding: "0px 8px" }}
                          >
                            <span
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "space-between",
                              }}
                            >
                              <span
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <span className="mx-1">
                                  {imageErrors.has(idx) ? (
                                    <div
                                      style={{
                                        width: 26,
                                        height: 21,
                                        backgroundColor: `hsl(${
                                          (idx * 57) % 360
                                        }, 70%, 60%)`,
                                        color: "#fff",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontSize: "12px",
                                        borderRadius: "2px",
                                      }}
                                    >
                                      {idx + 1}
                                    </div>
                                  ) : (
                                    <img
                                      height={17}
                                      width={17}
                                      src={`https://versionobj.ecoassetsservice.com/v40/static/front/img/greyhound/other/${
                                        idx + 1
                                      }.png`}
                                      onError={() => {
                                        setImageErrors((prev) =>
                                          new Set(prev).add(idx)
                                        );
                                      }}
                                    />
                                  )}
                                </span>
                                <span className="ml-1 text-[10px]">{`${formattedRunner}`}</span>
                              </span>
                              <span
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "space-around",
                                  alignItems: "center",
                                }}
                              >
                                <span>
                                  {filteredBets && filteredBets?.length > 0 && (
                                    <span
                                      style={{
                                        fontSize: "10px",
                                        color:
                                          placedBetCalculation < 0
                                            ? "red"
                                            : "green",
                                        display: "flex",
                                        paddingLeft: "4px",
                                      }}
                                    >
                                      <span className="text-[10px]">
                                        {placedBetCalculation < 0 ? "-" : ""}
                                      </span>
                                      {Math.abs(placedBetCalculation)?.toFixed(
                                        0
                                      )}
                                    </span>
                                  )}
                                </span>
                                {openWinLosValue &&
                                  filteredBets &&
                                  filteredBets?.length > 0 &&
                                  betData &&
                                  betData?.marketId == gmid &&
                                  (betData.calculateValue ||
                                    betData.addedValue) && (
                                    <span style={{ alignSelf: "center" }}>
                                      <FaArrowDownLong size={5} />
                                    </span>
                                  )}
                                <span>
                                  {openWinLosValue &&
                                    betData &&
                                    betData?.marketId == gmid &&
                                    (betData.calculateValue ||
                                      betData.addedValue) && (
                                      <span
                                        style={{
                                          fontSize: "10px",
                                          color: newValue < 0 ? "red" : "green",
                                          display: "flex",
                                        }}
                                      >
                                        <span
                                          style={{ marginRight: "2px" }}
                                          className="text-[10px]"
                                        >
                                          {newValue < 0 ? "-" : ""}
                                        </span>
                                        {Math.abs(newValue)?.toFixed(0)}
                                      </span>
                                    )}
                                </span>
                              </span>
                            </span>
                          </td>
                          {runner.gstatus === "REMOVED" && (
                            <div className="asian-full-market-inner">
                              {runner.gstatus} {runner.adfa + "%"} {runner.rdt}
                            </div>
                          )}
                          {(runner.status === "SUSPENDED" || selfSuspend) && (
                            <div className="asian-full-market-inner">
                              SUSPENDED
                            </div>
                          )}
                          {runner.gstatus === "REMOVED" || selfSuspend ? (
                            <td
                              className="removed-match text-[center]"
                              colSpan={6}
                            >
                              {runner.gstatus === "REMOVED" && (
                                <div className="removed-text">
                                  {runner.gstatus} {runner.adfa + "%"}{" "}
                                  {runner.rdt}
                                </div>
                              )}
                              {selfSuspend && (
                                <div className="removed-text">SUSPENDED</div>
                              )}
                            </td>
                          ) : (
                            <>
                              {[...Array(3)].map((_, i) => (
                                <td
                                  key={`back-${i}`}
                                  onClick={() => {
                                    runner.gstatus === "ACTIVE" &&
                                      handleDataClick(
                                        runner.nat,
                                        runner?.odds[i]?.odds,
                                        "Back",
                                        runner,
                                        i,
                                        idx,
                                        gOdds.section
                                      );
                                  }}
                                  className={`cursor-pointer asian-back${i}`}
                                >
                                  <span
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      justifyContent: "space-around",
                                      alignItems: "center",
                                    }}
                                  >
                                    <span>
                                      {runner?.odds[i]?.odds || "-"} <br />
                                    </span>
                                    <span style={{ fontSize: "8px" }}>
                                      {runner?.odds[i]?.size || "-"}
                                    </span>
                                  </span>
                                </td>
                              ))}
                              {[...Array(3)].map((_, i) => (
                                <td
                                  key={`lay-${i}`}
                                  onClick={() =>
                                    runner.gstatus === "ACTIVE" &&
                                    handleDataClick(
                                      runner.nat,
                                      runner?.odds[i + 3]?.odds,
                                      "Lay",
                                      runner,
                                      i,
                                      idx,
                                      gOdds.section
                                    )
                                  }
                                  className={`cursor-pointer asian-lay${i}`}
                                >
                                  <span
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      justifyContent: "space-around",
                                      alignItems: "center",
                                    }}
                                  >
                                    <span>
                                      {runner?.odds[i + 3]?.odds || "-"} <br />
                                    </span>
                                    <span style={{ fontSize: "8px" }}>
                                      {runner?.odds[i + 3]?.size || "-"}
                                    </span>
                                  </span>
                                </td>
                              ))}
                            </>
                          )}
                        </tr>
                        {localBetData?.runnerName === runner?.nat &&
                          localBetData?.odds !== 0 && (
                            <tr>
                              <td colSpan={isWideScreen ? 7 : 3}>
                                {selectedBet && (
                                  <BettingSlip
                                    oddsData={localBetData}
                                    betType={betType}
                                    index={index}
                                    matchIndex={matchIndex}
                                    onCancel={() => {
                                      setSelectedBet(null);
                                      setLocalBetData(null);
                                    }}
                                    matchesData={[]}
                                    newData={newData}
                                    nodelay={true}
                                    horseData={newData}
                                    minmax={{
                                      min: 100,
                                      max: gOdds.umaxbof || 5000,
                                      currentMatchExposure:
                                        getCurrentMatchExposure(filteredBets),
                                    }}
                                  />
                                )}
                              </td>
                            </tr>
                          )}
                      </>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Market;
